<template>
  <div class="bc" :class="{ 'bc--compacto': compacto }">
    <span v-if="etiqueta" class="bc-label">{{ etiqueta }}</span>

    <!-- Móvil: menú nativo de compartir (WhatsApp, Telegram, Instagram, SMS…) -->
    <button v-if="nativo" type="button" class="bc-btn bc-btn--nativo" @click="compartirNativo">
      <span class="material-symbols-outlined" aria-hidden="true">share</span>
      <span class="bc-btn-texto">Compartir</span>
    </button>

    <a
      :href="enlaces.whatsapp"
      target="_blank"
      rel="noopener"
      class="bc-btn bc-btn--whatsapp"
      aria-label="Compartir por WhatsApp"
      title="WhatsApp"
      @click="registrar('whatsapp')"
    >
      <svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true"><path fill="currentColor" d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2m.01 1.67c4.55 0 8.24 3.69 8.24 8.24 0 4.54-3.69 8.23-8.24 8.23-1.48 0-2.93-.39-4.19-1.15l-.3-.17-3.12.82.83-3.04-.2-.32a8.2 8.2 0 0 1-1.26-4.38c.01-4.54 3.7-8.23 8.24-8.23M8.53 7.33c-.16 0-.43.06-.66.31-.22.25-.87.86-.87 2.07 0 1.22.89 2.39 1 2.56.14.17 1.76 2.67 4.25 3.73.59.27 1.05.42 1.41.53.59.19 1.13.16 1.56.1.48-.07 1.46-.6 1.67-1.18s.21-1.07.15-1.18c-.07-.1-.23-.16-.48-.27-.25-.14-1.47-.74-1.69-.82-.23-.08-.37-.12-.56.12-.16.25-.64.81-.78.97-.15.17-.29.19-.53.07-.26-.13-1.06-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.12-.24-.01-.39.11-.5.11-.11.27-.29.37-.44.13-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14 0-.3-.01-.47-.01"/></svg>
    </a>
    <a
      :href="enlaces.facebook"
      target="_blank"
      rel="noopener"
      class="bc-btn bc-btn--facebook"
      aria-label="Compartir en Facebook"
      title="Facebook"
      @click="registrar('facebook')"
    >
      <svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true"><path fill="currentColor" d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4z"/></svg>
    </a>
    <a
      :href="enlaces.telegram"
      target="_blank"
      rel="noopener"
      class="bc-btn bc-btn--telegram"
      aria-label="Compartir por Telegram"
      title="Telegram"
      @click="registrar('telegram')"
    >
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path fill="currentColor" d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z"/></svg>
    </a>
    <a
      :href="enlaces.x"
      target="_blank"
      rel="noopener"
      class="bc-btn bc-btn--x"
      aria-label="Compartir en X (Twitter)"
      title="X"
      @click="registrar('x')"
    >
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.66l-5.21-6.82-5.97 6.82H1.67l7.73-8.84L1.25 2.25h6.83l4.71 6.23zm-1.16 17.52h1.83L7.08 4.13H5.12z"/></svg>
    </a>
    <a
      :href="enlaces.email"
      class="bc-btn"
      aria-label="Enviar por correo"
      title="Correo"
      @click="registrar('email')"
    >
      <span class="material-symbols-outlined" aria-hidden="true">mail</span>
    </a>
    <button
      type="button"
      class="bc-btn"
      :class="{ 'is-ok': copiado }"
      :aria-label="copiado ? 'Enlace copiado' : 'Copiar enlace'"
      :title="copiado ? 'Copiado' : 'Copiar enlace'"
      @click="copiar"
    >
      <span class="material-symbols-outlined" aria-hidden="true">{{ copiado ? "check" : "link" }}</span>
    </button>
  </div>
</template>

<script>
import { track } from "@/directives/analitica.js";
import { Constantes } from "@/directives/Constantes";

/**
 * Botones para compartir cualquier página o contenido.
 *
 * <botones-compartir titulo="Misa del Gallo" texto="24 dic, 00:00 en Santo Domingo"
 *   ruta="/Eventos?fecha=2026-12-24" tipo="evento" :id="…" />
 *
 * Si no se indica la ruta, se comparte la página actual. El enlace siempre es el
 * de la web real, para que la vista previa (título, foto) salga bien en WhatsApp.
 */
export default {
  name: "BotonesCompartir",
  props: {
    titulo: { type: String, default: "" },
    texto: { type: String, default: "" },
    ruta: { type: String, default: "" },
    tipo: { type: String, default: "pagina" }, // noticia, album, evento, horario, pagina…
    id: { type: [String, Number], default: "" },
    etiqueta: { type: String, default: "" },
    compacto: { type: Boolean, default: false },
  },
  data() {
    return {
      copiado: false,
      nativo: typeof navigator !== "undefined" && typeof navigator.share === "function",
    };
  },
  computed: {
    url() {
      const ruta = this.ruta || this.$route.fullPath;
      return /^https?:\/\//i.test(ruta) ? ruta : Constantes.sitio_web.replace(/\/+$/, "") + ruta;
    },
    mensaje() {
      return [this.titulo, this.texto].filter(Boolean).join(" · ");
    },
    enlaces() {
      const u = encodeURIComponent(this.url);
      const m = encodeURIComponent(this.mensaje);
      const lineas = encodeURIComponent((this.mensaje ? this.mensaje + "\n" : "") + this.url);
      return {
        whatsapp: `https://wa.me/?text=${lineas}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
        telegram: `https://t.me/share/url?url=${u}&text=${m}`,
        x: `https://twitter.com/intent/tweet?url=${u}&text=${m}`,
        email: `mailto:?subject=${encodeURIComponent(this.titulo || Constantes.nombre_sitio)}&body=${lineas}`,
      };
    },
  },
  methods: {
    registrar(metodo) {
      track("share", {
        method: metodo,
        content_type: this.tipo,
        item_id: String(this.id || this.ruta || this.$route.fullPath).slice(0, 100),
        item_name: (this.titulo || document.title).slice(0, 100),
      });
    },
    async compartirNativo() {
      try {
        await navigator.share({ title: this.titulo || document.title, text: this.mensaje, url: this.url });
        this.registrar("nativo");
      } catch (e) {
        // El visitante cerró el menú: no es un error
      }
    },
    async copiar() {
      try {
        await navigator.clipboard.writeText(this.url);
      } catch (e) {
        // Navegadores antiguos o sin permiso
        const campo = document.createElement("textarea");
        campo.value = this.url;
        campo.setAttribute("readonly", "");
        campo.style.position = "fixed";
        campo.style.opacity = "0";
        document.body.appendChild(campo);
        campo.select();
        document.execCommand("copy");
        document.body.removeChild(campo);
      }
      this.copiado = true;
      this.registrar("copiar_enlace");
      setTimeout(() => (this.copiado = false), 2000);
    },
  },
};
</script>

<style scoped>
.bc {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.bc-label {
  margin-right: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--sd-muted);
}

.bc-btn {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid var(--sd-border);
  border-radius: 999px;
  background: var(--sd-surface);
  color: var(--sd-text);
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.15s, background 0.15s, border-color 0.15s, color 0.15s;
}

.bc-btn:hover {
  border-color: var(--sd-primary);
  color: var(--sd-primary);
  text-decoration: none;
  transform: translateY(-1px);
}

.bc-btn .material-symbols-outlined {
  font-size: 19px;
  color: inherit;
}

.bc-btn--nativo {
  width: auto;
  padding: 0 14px;
  border-color: var(--sd-primary);
  background: var(--sd-primary);
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--sd-primary-contrast);
}

.bc-btn--nativo:hover {
  background: var(--sd-primary-strong);
  color: var(--sd-primary-contrast);
}

.bc-btn-texto {
  color: inherit;
}

.bc-btn--whatsapp:hover { border-color: #25d366; color: #128c4b; }
.bc-btn--facebook:hover { border-color: #1877f2; color: #1877f2; }
.bc-btn--telegram:hover { border-color: #229ed9; color: #229ed9; }

.dark .bc-btn--whatsapp:hover { color: #25d366; }
.dark .bc-btn--facebook:hover { color: #5b9dff; }

.bc-btn.is-ok {
  border-color: var(--sd-success);
  color: var(--sd-success);
}

.bc--compacto .bc-btn {
  width: 36px;
  height: 36px;
}

.bc--compacto .bc-btn--nativo {
  width: auto;
}
</style>
